import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router";
import Fontstyling, {
  clientListDrpDwnStyles,
} from "../../../components/common/comman";
import { selectedClientData } from "../../../Redux/Reducer/ClientDataReducer";
import RenewalAdjustment from "./RenewalAdjustement";
import UnderwritingAdjustment from "./UnderwritingAdjustment";
import FinalACGRateReview from "./FinalAcgRateReview";
import UnderwritingOutput from "./UnderwritingOutput";
import ExportReports from "./ExportReports";
import ClientList from "../../../components/common/ClientList";
import ClientRubs from "../Clientdata/ClientRubs";

const ReportExport = ({ navigate }) => {
  const client = useSelector((state) => state.clientData.value);
  const [clientData, setClientData] = useState([]);
  const [selectedClientvalue, setSelectedClientValue] = useState(null);
  const dispatch = useDispatch();

  const customStyles = {
    control: (base) => ({
      ...Fontstyling.primaryparagraph,
      display: "flex",
      alignItems: "center",
      border: "1px solid grey",
      width: "330px",
      maxHeight: "35px",
      height: "35px",
      textAlign: "left",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        ...Fontstyling.primaryparagraph,
        textAlign: "left",
        backgroundColor:
          data.value === 0 ? "#fff" : isFocused ? "#3498ff" : null,
        color: data.value === 0 ? "#808080" : isFocused ? "white" : "#212529",
        fontSize: 12,
        paddingTop: 0,
        paddingBottom: 0,
      };
    },
  };

  useEffect(() => {
    if (client !== null && client?.client !== 0)
      setSelectedClientValue({
        value: client?.clientID,
        label: client?.clientName,
      });
    else {
      setSelectedClientValue({
        value: 0,
        label: "SELECT CLIENT NAME",
      });
    }
  }, []);

  const handleClientChange = (option) => {
    setSelectedClientValue(option);
    let clientobj = clientData.find((item) => item.clientID === option.value);
    dispatch(selectedClientData(clientobj));
  };

  return (
    <>
      <div className="d-md-flex d-block align-items-center justify-content-between py-3 border-bottom mb-3">
        <div className="d-flex gap-3">
          <ClientList
            clientData={clientData}
            setClientData={setClientData}
            customStyles={{
              ...clientListDrpDwnStyles,
              control: (base) => ({
                ...clientListDrpDwnStyles.control(base),
                width: "330px",
                border: "1px solid grey",
                maxHeight: "35px",
                height: "35px",
              }),
            }}
            handleClientChange={handleClientChange}
            selectedClientvalue={selectedClientvalue}
            setSelectedClientValue={setSelectedClientValue}
          />
        </div>
      </div>

      <Routes>
        <Route index element={<RenewalAdjustment navigate={navigate} />} />
        <Route
          path="/renewaladj"
          element={<RenewalAdjustment navigate={navigate} />}
        />
        <Route
          path="/underwritingadj"
          element={<UnderwritingAdjustment navigate={navigate} />}
        />
        <Route path="/ratereview" element={<FinalACGRateReview />} />
        <Route path="/underwritingop" element={<UnderwritingOutput />} />
        <Route
          path="/clientrubs"
          element={<ClientRubs navigate={navigate} />}
        />
        <Route
          path="/rptexport"
          element={<ExportReports selectedClientvalue={selectedClientvalue} />}
        />
      </Routes>
    </>
  );
};

export default ReportExport;
